// extracted by mini-css-extract-plugin
export var buttons = "_9f-0";
export var buttonsActive = "_9f-h";
export var cancelConfirm = "_9f-1";
export var closeButton = "_9f-2";
export var column = "_9f-3";
export var container = "_9f-4";
export var detailHeader = "_9f-6";
export var detailTitle = "_9f-7";
export var detailsContent = "_9f-5";
export var header = "_9f-8";
export var headerWithClose = "_9f-9";
export var icon = "_9f-a";
export var infoIcon = "_9f-c";
export var informationContainer = "_9f-b";
export var sideDrawer = "_9f-d";
export var sideDrawerOpen = "_9f-e";
export var stickyFooter = "_9f-f";
export var typeOption = "_9f-g";